import intercom from '@intercom/messenger-js-sdk'
import store from 'store'

intercom({
  app_id: 'gcu2chnc',
  user_id: store.getters.uuid,
  name: store.getters.username,
  email: store.getters.email,
  created_at: new Date().getTime() - store.state.timegap.localServerTimeGap
})

store.watch(
  () => store.getters.uuid,
  (uuid) => {
    if (uuid) {
      intercom('boot', {
        app_id: 'gcu2chnc',
        user_id: store.getters.uuid,
        name: store.getters.username,
        email: store.getters.email,
        created_at: new Date().getTime() - store.state.timegap.localServerTimeGap
      })
    } else {
      intercom('shutdown')
    }
  }
)
